// Read-only presentation. Official saved match flags always take precedence.
const {isNearMatch,CRITERIA}=require('./drawingNearCriteria');
function memberNearAnalysis(rows,main){
 return rows.flatMap((row,order)=>row.slots.filter(p=>!p.locked&&isNearMatch({selection:p.number,matches:p.types},main)).map(p=>({strategy:row.strategy,rank:p.rank,number:p.number,order,positions:[...p.number].filter((n,i)=>n===main[i]).length})))
  .sort((a,b)=>b.positions-a.positions||a.rank-b.rank||a.order-b.order).map(({strategy,rank,number})=>({strategy,rank,number}));
}
module.exports={memberNearAnalysis,CRITERIA};
